import { useEffect } from 'react';

/**
 * Loads the FontAwesome stylesheet on demand the first time an icon mounts,
 * instead of bundling it into the layout CSS on every page.
 *
 * The stylesheet is a flattened static asset generated by scripts/build-fa-css.js
 * (served from /fa/fontawesome.css). A <link> is appended to <head> once per page
 * load and guarded against duplicates.
 */
const FA_STYLE_ID = 'fa-styles';
const FA_STYLE_HREF = '/fa/fontawesome.css';

let injected = false;

export function useFontAwesome() {
  useEffect(() => {
    if (injected || document.getElementById(FA_STYLE_ID)) {
      injected = true;
      return;
    }

    injected = true;
    const link = document.createElement('link');
    link.id = FA_STYLE_ID;
    link.rel = 'stylesheet';
    link.href = FA_STYLE_HREF;
    document.head.appendChild(link);
  }, []);
}
